import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TenantSelectorComponent } from './components/tenant-selector/tenant-selector.component';
import { ControlsModule } from '../controls/controls.module';
import { TenantService } from './service/tenant.service';
import { TenantSelectorTransform } from './pipes/tenant-selector-transform';

@NgModule({
	declarations: [TenantSelectorComponent],
	imports: [ControlsModule, CommonModule, TranslateModule],
	providers: [TenantService, TenantSelectorTransform],
	exports: [],
})
export class TenancyModule {}

export * from './components/tenant-selector/tenant-selector.component';
export * from './service/tenant.service';
export * from './types/tenant';
export * from './util/tenant-params';
